<div *ngIf="!loading">
  <p class="mb-3">
    Selecione as permissões para
    <strong>{{ user.displayName }}</strong> (<code>{{ user.dbUsername }}</code
    >):
  </p>

  <div class="permissions-list">
    <div *ngFor="let perm of permissionOptions" class="field-checkbox">
      <p-checkbox
        [binary]="true"
        [(ngModel)]="perm.checked"
        [inputId]="perm.value"
        [label]="perm.label"
      ></p-checkbox>
    </div>
  </div>

  <div class="flex justify-content-end gap-2 mt-4">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="ref.close(false)"
    ></button>
    <button
      pButton
      type="button"
      label="Salvar permissões"
      (click)="submit()"
    ></button>
  </div>
</div>
